import { TagSelector } from "@src/pages/Routines/CreateRoutine/TagSelector";
import { Tag } from "data-hooks/company/tags/tags.type";
import { formatTagName } from "data-hooks/company/tags/tags.utils";
import { LocalData } from "to-be-removed/LocalData/General/LocalData";
import { CustomFieldDataOptions } from "../../../Property/Collections/PropertyCustomFieldData";
import { CustomFieldDataTypeHelper, DataEditorContext } from "./CustomFieldDataTypeHelper";

export class CustomFieldTagsDataType extends CustomFieldDataTypeHelper<Tag[]> {
  getDataEditor(
    data: any | undefined,
    options: CustomFieldDataOptions,
    context: DataEditorContext,
    setRawData: (data: string[] | undefined) => void
  ): JSX.Element {
    return (
      <TagSelector
        width="100%"
        propertyId={context.propertyID}
        companyId={context.company?.id}
        changedSelected={(selectedTags) => {
          if (Array.isArray(selectedTags)) {
            const selectedTagsIds = selectedTags.map((tag) => tag.id);
            setRawData(selectedTagsIds);
          } else {
            setRawData([]);
          }
        }}
        defaultSelected={data}
        menuPortalTarget={context.menuPortalTarget}
      />
    );
  }

  getStringRepresentation(data: any | undefined, options: CustomFieldDataOptions, context: DataEditorContext): string | Promise<string> {
    if (typeof data === "string") {
      return formatTagName(LocalData.getTagWithId(data) as Tag);
    }
    return "";
  }
}
